module.exports = __webpack_public_path__ + "img/beer_id-7.ee1bf9c7.png";